module.exports = __webpack_public_path__ + "f881fc7eacb343fd62763018681b1568.jpg";